import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard = async () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  if (await authService.isLoggedIn()) {
    return true;
  }

  return router.parseUrl('/login');
}; 